
import { useCallback, useContext } from 'react';
import { Button, Container, Nav, Navbar, NavDropdown, NavItem } from 'react-bootstrap';
import { ThemeContext } from '../App';
import './Layout.scss';
import DiscordImg from '../assets/img/discord.svg';
import TelegramImg from '../assets/img/twitter.svg';
import { WalletNotConnectedError } from '@solana/wallet-adapter-base';
import { useConnection, useWallet } from '@solana/wallet-adapter-react';
import { Keypair, SystemProgram, Transaction } from '@solana/web3.js';
import { WalletDisconnectButton, WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import LogoImg from '../assets/img/logo.png';

function AppHeader(props: any) {
    const { theme, setTheme } = useContext(ThemeContext);

    const { connection } = useConnection();
    const { publicKey, sendTransaction, wallet, connect, disconnect } = useWallet();

    const connectWallet = ()=>{
      console.log('connect wallet');
      connect();
    };
    console.log('app header props ======== ', wallet, publicKey);
    return <Navbar expand="lg" sticky='top' id="appHeader" variant='dark' className='p-3'>
    {/* <Container> */}
      <Navbar.Brand href="#home"><img src={LogoImg}/></Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ms-auto">
          <Nav.Link href="https://discord.gg/qrWAD67Y7N" title='discord'><img src={DiscordImg} className="nav-social-icon" /></Nav.Link>
          <Nav.Link href="https://twitter.com/solporate" title='Twitter'><img src={TelegramImg} className="nav-social-icon" /></Nav.Link>
          <Nav.Link href="#info" className="top-link">Info</Nav.Link>
          <Nav.Link href="#roadmap" className="top-link">Roadmap</Nav.Link>
          <Nav.Link href="https://medium.com/@solporate_neo/solporate-16a87b908644" target="_blank" className="top-link">White Paper</Nav.Link>
          <Nav.Link href="#team" className="top-link me-2">Team</Nav.Link>
          {/* <NavDropdown title="Dropdown" id="basic-nav-dropdown">
            <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
            <NavDropdown.Item href="#action/3.2">Another action</NavDropdown.Item>
            <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item href="#action/3.4">Separated link</NavDropdown.Item>
            <NavDropdown.ItemText><a href='https://google.com'>Google</a></NavDropdown.ItemText>
          </NavDropdown> */}
          <NavItem>
            {/* <Button onClick={connectWallet}>Connect Wallet</Button> */}
            <WalletMultiButton />
            {/* <WalletDisconnectButton /> */}
          </NavItem>
        </Nav>
      </Navbar.Collapse>
    {/* </Container> */}
  </Navbar>
}

export default AppHeader;